var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5013 3.5212L14.1557 8.61279C14.3017 9.06222 14.7205 9.3665 15.1931 9.3665L20.5467 9.36651C21.119 9.36651 21.357 10.0989 20.894 10.4353L16.5628 13.582C16.1805 13.8598 16.0205 14.3521 16.1665 14.8016L17.8209 19.8932C17.9977 20.4375 17.3748 20.8901 16.9118 20.5537L12.5806 17.4069C12.1983 17.1291 11.6806 17.1291 11.2983 17.4069L6.96713 20.5537C6.50412 20.8901 5.88114 20.4375 6.058 19.8932L7.71236 14.8016C7.85838 14.3521 7.69841 13.8598 7.3161 13.582L2.98494 10.4353C2.52193 10.0989 2.75988 9.36651 3.33219 9.36651L8.68581 9.3665C9.15837 9.3665 9.57718 9.06222 9.72321 8.61279L11.3776 3.5212C11.5544 2.9769 12.3245 2.9769 12.5013 3.5212Z",
    fill: "url(#paint0_linear_0_1290)",
    stroke: "#00DBFF",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1290",
    x1: 0.168396,
    y1: 12.754,
    x2: 23.7105,
    y2: 12.754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalf);
export default __webpack_public_path__ + "static/media/star-half.655cbf43397b580ff04dcb9709d12932.svg";
export { ForwardRef as ReactComponent };